import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=f80205b8&scoped=true&"
import script from "./Basics.vue?vue&type=script&lang=js&"
export * from "./Basics.vue?vue&type=script&lang=js&"
import style0 from "./Basics.vue?vue&type=style&index=0&id=f80205b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80205b8",
  null
  
)

export default component.exports